import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DashboardItem} from '../../dashboard.model';
import {loadDashboardStart} from '../../store/actions/getDashboard.actions';
import { Store} from '@ngrx/store';
import {State} from '../../store/reducer/landingpage.reducer';
import {MatDialog} from '@angular/material/dialog';
import {deleteDashboardStart} from '../../store/actions/dashboard-del.actions';
import {startTimeDashboardStart} from '../../store/actions/dashboard-startTime.actions';
import {stopTimeDashboardStart} from '../../store/actions/dashboard-stopTime.actions';
import {ZeiterfassungFormdialogNeuComponent} from '../../../Zeiterfassung/components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {loadProjektSelectboxStart} from '../../../Zeiterfassung/store/actions/project-selectbox.actions';
import {BestaetigungsFormComponent} from '../../../../ui-components/bestaetigungs-form/bestaetigungs-form.component';
import {loadSpesenStart} from "../../../Zeiterfassung/store/actions/getAllSpesen.actions";
import {addZeitStart} from "../../../Zeiterfassung/store/actions/Zeit-add.actions";
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {pauseTimeDashboardStart} from '@src/app/pages/landingpage/store/actions/dashboard-pauseTime.actions';
import {continueTimeDashboardStart} from '@src/app/pages/landingpage/store/actions/dashboard-continueTime.actions';

@Component({
    selector: 'app-landing-card',
    templateUrl: './landing-card.component.html',
    styleUrls: ['./landing-card.component.scss'],
})
export class LandingCardComponent implements OnInit, OnDestroy {


  constructor(private store: Store<{ landingpage: State }>,
              public dialog: MatDialog,
              private breakpointObserver: BreakpointObserver
  ) {
  }

  @Input()
  dashboardItems: DashboardItem[] = [];
  public isSmallDevice = false;
  public myTimer: any;
  public dashboardItem: DashboardItem;

    public ngOnInit(): void {

      this.breakpointObserver
        .observe(localStorage.getItem('phoneWidth'))
        .pipe(map((result) => result.matches))
        .subscribe((isSmallDevice) => {
          this.isSmallDevice = isSmallDevice;

        });

      this.store.dispatch(loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}));
      // tslint:disable-next-line:only-arrow-functions


      this.myTimer = setInterval( function(): void{
        if ( sessionStorage.getItem('userId') !== null ){
          document.getElementById('timerButton').click();
        }

      }  , 1000);
    }
  public ngOnDestroy(): void {
    clearInterval(this.myTimer);
  }

    public delete(dashItem: DashboardItem): void{
      const bestätigungsForm = this.dialog.open(BestaetigungsFormComponent, {
        data: {
          title: 'pages.landingpage.deleteDashboard.title',
          text: 'pages.landingpage.deleteDashboard.text'
        },
      });
      bestätigungsForm.afterClosed().subscribe(result => {
        if (result === true){
          this.store.dispatch(deleteDashboardStart({ item: dashItem}));
        }
      });
    }

  public startTime(dashItem: DashboardItem): void{
      this.store.dispatch(startTimeDashboardStart({ item: dashItem}));
  }

  public pauseTime(dashItem: DashboardItem): void{
      this.store.dispatch(pauseTimeDashboardStart({ item: dashItem}));
  }

  public continueTime(dashItem: DashboardItem): void{
    this.store.dispatch(continueTimeDashboardStart({ item: dashItem}));
  }

  public stopTime(dashItem: DashboardItem): void{
    this.store.dispatch(loadProjektSelectboxStart({projektId: dashItem.prjId}));
    this.store.dispatch(addZeitStart());
    this.store.dispatch(loadSpesenStart({zeitId: 0} ));

    if(this.isSmallDevice){
    const zeitForm = this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
      minWidth: '100vw',
      height: '100vh',
      data: {
        title: 'pages.addTimeDialog.title',
        spesenTitle: 'pages.addTimeDialog.spesenTitle',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        projekt: dashItem.prjId,
        dauerIntern: (parseFloat(dashItem.start) / 3600),
        dauerExtern: (parseFloat(dashItem.start) / 3600),
      },
    });
    zeitForm.afterClosed().subscribe(result => {
      if (result === 'stopTheButton'){
        this.store.dispatch(stopTimeDashboardStart({ item: dashItem}));
      }
    });
    }
    else{
      const zeitForm = this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
        data: {
          title: 'pages.addTimeDialog.title',
          spesenTitle: 'pages.addTimeDialog.spesenTitle',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          projekt: dashItem.prjId,
          dauerIntern: (parseFloat(dashItem.start) / 3600),
          dauerExtern: (parseFloat(dashItem.start) / 3600),
        },
      });
      zeitForm.afterClosed().subscribe(result => {
        if (result === 'stopTheButton'){
          this.store.dispatch(stopTimeDashboardStart({ item: dashItem}));
        }
      });
    }
    // this.store.dispatch(stopTimeDashboardStart({ item: dashItem}));
  }

  public addForm(projektId: number): void{
    this.store.dispatch(loadProjektSelectboxStart({projektId}));
    // Zeit in Datenbank erstellen und ID mit in Formular geben via Session
    this.store.dispatch(addZeitStart());
    this.store.dispatch(loadSpesenStart({zeitId: 0} ));

    if(this.isSmallDevice){
    this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
      minWidth: '100vw',
      height: '100vh',
      data: {
        title: 'pages.addTimeDialog.title',
        spesenTitle: 'pages.addTimeDialog.spesenTitle',
        submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
        cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
        dauerIntern: 0,
        dauerExtern: 0,
        projekt: projektId,
      },
    });
    }
    else{
      this.dialog.open(ZeiterfassungFormdialogNeuComponent, {
        data: {
          title: 'pages.addTimeDialog.title',
          spesenTitle: 'pages.addTimeDialog.spesenTitle',
          submitButtonLabel: 'pages.addTimeDialog.submitButtonLabel',
          cancelButtonLabel: 'pages.addTimeDialog.cancelButtonLabel',
          dauerIntern: 0,
          dauerExtern: 0,
          projekt: projektId,
        },
      });
    }
  }

  public findCorrectFontColor(color: any): string{

    // Variables for red, green, blue values
    // tslint:disable-next-line:one-variable-per-declaration
    let r, g, b, hsp;

    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

      // If RGB --> store the red, green, blue values in separate variables
      color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

      r = color[1];
      g = color[2];
      b = color[3];
    }
    else {

      // If hex --> Convert it to RGB: http://gist.github.com/983661
      color = +('0x' + color.slice(1).replace(
        color.length < 5 && /./g, '$&$&'));

      r = color >> 16;
      g = color >> 8 & 255;
      b = color & 255;
    }

    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );
/*
    const rgb = color.substring(4, color.length - 1)
      .replace(/ /g, '')
      .split(',');
    // http://www.w3.org/TR/AERT#color-contrast
    const brightness = Math.round(((parseInt(rgb[0]) * 299) +
      (parseInt(rgb[1]) * 587) +
      (parseInt(rgb[2]) * 114)) / 1000);
    const textColour = (brightness > 115) ? 'blackFont' : 'whiteFont';
    return textColour;
    */
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {

      return 'blackFont';
    }
    else {

      return 'whiteFont';
    }
  }

  public timer(): void{
    this.store.dispatch(loadDashboardStart({userId: parseInt(sessionStorage.getItem('userId'))}));
  }

}
